import React from "react";
import { jobsheetsRef } from "../firebase";
import { useDeltaSyncedCollection } from "../customHooks/useDeltaSyncedCollection";

const JobsheetsContext = React.createContext({});

// All jobsheets created by the user's associated accounts - kept in sync with Firestore through
// this device's cache plus a listener on recently modified documents, so every jobsheet is
// available to list and search, not just recent ones. See useDeltaSyncedCollection.
const JobsheetsProvider = (props) => {
  const { docs, loading } = useDeltaSyncedCollection(jobsheetsRef);

  return (
    <JobsheetsContext.Provider value={{ timesheets: docs, loading }}>
      {props.children}
    </JobsheetsContext.Provider>
  );
};

export { JobsheetsProvider, JobsheetsContext };
